import * as React from "react";

import { DashboardLink, LinkProps } from "@/dashboard-design-system/Link";

type NewTabLinkProps = LinkProps & { href: NonNullable<LinkProps["href"]> | undefined; stopClickPropagation?: boolean };

export const NewTabLink: React.FunctionComponent<NewTabLinkProps> = ({
  target = "_blank",
  onClick,
  stopClickPropagation = true,
  ...rest
}) => {
  const handleOnClick: LinkProps["onClick"] = React.useCallback(
    (event: React.KeyboardEvent<HTMLAnchorElement> | React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      if (stopClickPropagation) {
        event.stopPropagation();
      }
      onClick?.(event);
    },
    [stopClickPropagation, onClick]
  );

  return <DashboardLink {...rest} target={target} onClick={handleOnClick} />;
};
